import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {I18n} from 'react-redux-i18n';

const searchFocusHack = () => {
  document.getElementById("searchPhrase").focus();
};

const CareSheetInfo = ({
	careSheet
}) => {
 

  return (
		<div className="col-lg-6 col-sm-12 col-pet">
      <div className="media">
        <div className="mr-3 align-self-start">
          <img src={careSheet.ImageURL} alt={careSheet.Name} />
        </div>
        <div className="media-body">
          <h5><Link to={careSheet.PDFURL} target="_blank">{careSheet.Line1}</Link></h5>
          <h6>{careSheet.Line2}</h6>
          <h6>{careSheet.Line3}</h6>
          <div className="row plu-barcode no-gutters">
              <span className="plu">{careSheet.Line4}</span>
          </div>
          <Link to={careSheet.PDFURL} target="_blank" onClick={searchFocusHack} className="btn btn-primary">{I18n.t('DOWNLOAD')}</Link>
        </div>
      </div>
    </div>
	);
};

CareSheetInfo.propTypes = {
	careSheet: PropTypes.object.isRequired
};

export default CareSheetInfo;


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/CareSheetInfo.js
 **/